export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.filmhookapps&hl=en_IN";
export const EDITOR_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.filmhookapps.filmhook_editor&hl=en_IN";
export const AI_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.filmhookai&hl=en_IN";
export const APP_STORE_URL = "https://apps.apple.com/us/app/filmhook/id6793529515";

